<script setup lang="ts">
withDefaults(
  defineProps<{
    values?: string[]
  }>(),
  {
    values: () => [],
  },
)
</script>

<template>
  <div v-if="values.length" class="flex flex-wrap">
    <div
      v-for="value in values"
      :key="value"
      class="my-1 mr-2 rounded-sm bg-gray-200 px-3 py-2.5 text-sm font-bold leading-none text-gray-400"
    >
      {{ value }}
    </div>
  </div>
  <div v-else>/</div>
</template>
